import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  ApplicationSectionHeader,
  ApplicationStateRegion,
  ApplicationSurface,
} from "../../../components/application";
import {
  listAssignedAssignments,
} from "../../assignments/services/assignmentApi";
import {
  formatAssignmentDate,
  participantActionLabel,
  participantProgressLabel,
  targetLabel,
} from "../../assignments/views/assignmentViewUtils";
import "../../assignments/views/assignmentPresentation.css";

export default function AssignedWorkSection({
  title,
  description,
  headingLevel = 2,
}) {
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    async function loadAssignments() {
      try {
        setLoading(true);
        const loadedAssignments =
          await listAssignedAssignments();

        if (active) {
          setAssignments(loadedAssignments);
          setError("");
        }
      } catch (_loadError) {
        if (active) {
          setError(
            "Assigned work could not be loaded. Please try again."
          );
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    loadAssignments();

    return () => {
      active = false;
    };
  }, []);

  const content = loading ? (
    <ApplicationStateRegion
      status="loading"
      message="Loading assigned work..."
    />
  ) : error ? (
    <ApplicationStateRegion
      status="error"
      message={error}
    />
  ) : assignments.length === 0 ? (
    <ApplicationStateRegion
      status="empty"
      message="No assigned work yet."
      detail="When a facilitator assigns an activity to you, it will appear here."
    />
  ) : (
    <ApplicationSurface>
      <div className="app-table-container">
        <table className="app-table av-assignment-table">
          <thead>
            <tr>
              <th>Assignment</th>
              <th>Activity</th>
              <th>Due</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {assignments.map((assignment) => (
              <tr key={assignment._id}>
                <td data-label="Assignment">{assignment.title}</td>
                <td data-label="Activity">{targetLabel(assignment.target)}</td>
                <td data-label="Due">{formatAssignmentDate(assignment.dueAt)}</td>
                <td data-label="Status">
                  {participantProgressLabel(assignment.progress)}
                </td>
                <td data-label="Action" className="av-assignment-table__action">
                  <Link className="av-app-button av-app-button--secondary av-app-button--compact" to={`/app/assigned-work/${assignment._id}`}>
                    {participantActionLabel(assignment.progress)}
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ApplicationSurface>
  );

  if (!title) {
    return content;
  }

  return (
    <section aria-labelledby="assigned-work-section-title">
      <ApplicationSectionHeader
        description={description}
        headingLevel={headingLevel}
        title={title}
        titleId="assigned-work-section-title"
      />

      {content}
    </section>
  );
}
